var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImmediatecommunication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 67,
    viewBox: "0 0 72 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3408_8535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.26334 63.5319V8.46075C1.26167 8.17167 1.31711 7.88513 1.42635 7.61772C1.5356 7.35031 1.69652 7.10735 1.89981 6.90294C2.1031 6.69852 2.34469 6.5367 2.61062 6.42685C2.87655 6.317 3.16155 6.26129 3.44904 6.26298H68.5509C68.8384 6.26129 69.1234 6.317 69.3894 6.42685C69.6553 6.5367 69.8969 6.69852 70.1002 6.90294C70.3035 7.10735 70.4644 7.35031 70.5736 7.61772C70.6829 7.88513 70.7382 8.17167 70.7366 8.46075V51.4251C70.7366 52.008 70.5064 52.567 70.0965 52.9792C69.6866 53.3913 69.1306 53.6229 68.5509 53.6229H18.3821C17.8423 53.6241 17.3215 53.8228 16.9166 54.1818L4.91453 65.1452C4.60187 65.4294 4.21416 65.6166 3.79812 65.6843C3.38208 65.752 2.95543 65.6974 2.5696 65.5269C2.18376 65.3564 1.85521 65.0773 1.62345 64.7234C1.39169 64.3694 1.26661 63.9556 1.26334 63.5319Z",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 15C59.866 15 63 11.866 63 8C63 4.13401 59.866 1 56 1C52.134 1 49 4.13401 49 8C49 11.866 52.134 15 56 15Z",
    fill: "#DD44B9",
    stroke: "#09090B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 26H60M12 38H42",
    stroke: "#09090B",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3408_8535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 67,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmediatecommunication);
export default __webpack_public_path__ + "static/media/immediatecommunication.440a56aac803b060f10263390322b80a.svg";
export { ForwardRef as ReactComponent };